<script>
  import { _ } from 'svelte-i18n'
  import { modals, storefront_id_to_edit, user_storefronts, previews_storefronts_filter, previews_font_size, previews_tracking, text_entered, text_entered_once, text_previewed, text_caseapplied, previews_sort_order, detected_fonts, storefront_just_created } from '../stores'
  import FontsBundle from './FontsBundle.svelte';
  import StorefrontsEmptyState from '../content/StorefrontsEmptyState.svelte';
  import Button from '../elements/Button.svelte'

  export let storefront_fonts;
  // Assuming $user_storefronts might be undefined on startup
  $: storefront_display = ($user_storefronts || []).map(storefront => ({
    storefront,
    fonts: storefront_fonts.filter(font => font.storefronts.some(s => s.id == storefront.id))
  }));

  function handleStorefrontClick(selected_storefront) {
    previews_storefronts_filter.toggleStorefront(selected_storefront.id)
    // load saved properties
    $previews_font_size = selected_storefront.font_scale
    $previews_tracking = selected_storefront.tracking
    $text_entered = selected_storefront.default_text
    $text_previewed = selected_storefront.default_text
    $text_caseapplied = selected_storefront.default_text
    $previews_sort_order = selected_storefront.sort_order
    // simulate text entry from cover
    $text_entered_once = true
  }

  function getFontsCountText(count) {
    if (count === 0) return $_('storefronts.zeroFonts');
    if (count === 1) return $_('storefronts.oneFont');
    return $_('storefronts.fontsCount', { values: { count }});
  }

</script>

{#if $user_storefronts && $user_storefronts.length !== 0}
  <div class="storefrontsIndex">
    {#each storefront_display as {storefront, fonts}}
      <div class="storefront" on:click={() => handleStorefrontClick(storefront)}>
        <div class="header">
          <p>
            {storefront.name}<small> {getFontsCountText(fonts.length)}</small>
          </p>
        </div>
        <FontsBundle
          fonts_to_display={fonts}
          wordmark_to_display={storefront.default_text}>
        </FontsBundle>
      </div>
    {/each}
  </div>
  {#if $user_storefronts.length === 1 && $storefront_just_created}
    <p class="singleStorefrontInfo">
      <b>Here’s your storefront!</b><br>
      Click to edit details and add fonts.
    </p>
  {/if}
{:else}
  <!-- Storefront index with no Storefronts -->
  <StorefrontsEmptyState/>
{/if}

<style>
  .storefrontsIndex {
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;
    padding: 3rem;
    justify-content: center;
    align-items: flex-start;
    background-color: var(--c-bg);
  }
  .storefront {
    cursor: pointer;
    border: 5px solid var(--c-text-faded-big);
    border-radius: 1rem;
  }
  .storefront .header {
    padding: 0.5rem 1rem 1rem;
    background-color: var(--c-text-faded-big);
  }
  .storefront .header p {
    padding: 0.5rem 1.5rem;
    border-radius: 2rem;
    font-variant-numeric: lining-nums;
    background-color: var(--c-bg);
  }
  .storefront .header small {
    float: right;
    font-size: 1.2rem;
    font-family: var(--PensumSans-Bold);
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--c-text-faded);
  }
  .storefront:hover .header p,
  .storefront:hover .header small{
    color: var(--c-accent);
  }
  .singleStorefrontInfo {
    width: 100%;
    text-align: center;
  }
  .singleStorefrontInfo b {
    color: var(--c-accent);
  }
</style>
